blue.ready('checklistForm', '.checklistForm', element => {
	let inner = element.querySelector('.checklistForm-inner');
	let open = document.querySelector('.askQuestion-button');
	let close = element.querySelector('.checklistForm-close');
	let form = element.querySelector('.checklistForm-form');
	let success = element.querySelector('.checklistForm-success');
	success.style.display = "none";

	open.addEventListener('click', function (e) {
		e.preventDefault();
		//console.log('open');
		blue.meth.bodyLock.lock(element);
		element.classList.toggle('is-open');
		dataLayer.push({
			'event':'VirtualPageView',
			'virtualPageURL':'/have-a-question-form/',
			'virtualPageTitle' : 'Have A Question Form | UHCU'
			});
		// When the modal is shown, we want a fixed body
		document.body.style.position = 'fixed';
		document.body.style.top = `-${window.scrollY}px`;
	})

	close.addEventListener('click', function (e) {
		e.preventDefault();
		//console.log('close');
		blue.meth.bodyLock.unlock(element);
		element.classList.toggle('is-open');

		// When the modal is hidden...
		const scrollY = document.body.style.top;
		document.body.style.position = '';
		document.body.style.top = '';
		window.scrollTo(0, parseInt(scrollY || '0') * -1);
	})

	element.addEventListener('mousedown', function (e) {
		if(!e.target.classList.contains('btn')){
			close.click();
		}
	})

	inner.addEventListener('mousedown', function (e) {
		if(!e.target.classList.contains('btn')){
			e.stopPropagation();
		}
	})

	const init = function () {
		const urlParams = new URLSearchParams(window.location.search);
		const successQuery = urlParams.get('success');

		if(successQuery && successQuery === "true"){
			
			element.classList.toggle('is-open')
			success.style.display = "block";
			form.style.display = "none";
		}

	}

	init();
})
